// ======================================================================
// File Name       : ThumbNail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React from 'react';
import { Form, FormControl, Col, Row, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import FileUpload from '../../components/FileUpload';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import {
  INITIAL_IMAGE,
  TITLE_OBJ_STR,
  TITLE_OBJ,
  IMAGE_TYPE_INT,
  DEFAULT_THUMBNAIL,
} from '../../constants/InitialImageConstants';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE, ROOT_URL } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import { hasProperty, getItemBoxName } from '../../utils/index';
import PaginationCustom from '../Pagination';
import NoImage from '../../images/no-image-icon.png';

class ThumbNail extends React.Component {
  render() {
    const { handleImageFileChange, formValues, radioChange } = this.props;
    const acceptFile = 'image/png,image/jpg,image/*';
    let $imagePreview = <img alt="150x150" height="150" width="150" src={NoImage} />;

    // How to access a single key or value
    let thumbnailPreview = null;
    let changed = false;
    if (formValues && Object.keys(formValues).length) {
      thumbnailPreview = Object.keys(formValues).map((childKey) => {
        changed = formValues[childKey].changed;
        if (
          hasProperty(formValues[childKey], 'thumbnailUrlFileLoad') &&
          formValues[childKey].imageFileSelectType === INITIAL_IMAGE.IMAGE_SELECTION
        ) {
          $imagePreview = (
            <img
              className="img"
              alt="150x150"
              height="150"
              width="150"
              src={formValues[childKey].thumbnailUrlFileLoad || NoImage}
            />
          );
        } else if (
          formValues[childKey].thumbnailUrl &&
          formValues[childKey].thumbnailUrl !== '' &&
          formValues[childKey].imageFileSelectType === INITIAL_IMAGE.IMAGE_SYSTEMS
        ) {
          $imagePreview = (
            <img
              alt="150x150"
              height="150"
              width="150"
              className="img"
              src={formValues[childKey].thumbnailUrl}
            />
          );
        } else {
          $imagePreview = <img alt="150x150" height="150" width="150" src={NoImage} className="img" />;
        }
        const isSelectedFile = !!(
          formValues[childKey].imageFileSelectType &&
          formValues[childKey].imageFileSelectType === INITIAL_IMAGE.IMAGE_SELECTION
        );
        const keyTemp = formValues[childKey].name;
        return (
          <Form.Group className="form-info" key={keyTemp}>
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>
                {formValues[childKey].titleName}
              </Col>
              <Col as={Form.Label} sm={3} className="ps-0">
                設定されている画像
              </Col>
              <Col as={Form.Label} sm={7}>
                設定する画像ファイルを指定してください
              </Col>
            </Col>
           
            <Col sm={12} className="margin-bottom-5">
              <Row>
                <Col sm={2} className="flex-shrink-0" />
                <Col sm={3}>{$imagePreview}</Col>
                <Col sm={7}>
                  <Col sm={12}>
                    <Col sm={12} className="margin-left-20">
                      <RenderField
                        type="radio"
                        name={`${childKey}.imageFileSelectType`}
                        value={INITIAL_IMAGE.IMAGE_SYSTEMS}
                        label="初期画像"
                        normalizeRadio
                        checkRadioChange
                        radioChange={radioChange}
                      />
                    </Col>
                  </Col>
                  <Col sm={12} className="margin-left-20 margin-top-20 label-middle">
                    <Col className="margin-right-20">
                      <RenderField
                        type="radio"
                        name={`${childKey}.imageFileSelectType`}
                        value={INITIAL_IMAGE.IMAGE_SELECTION}
                        normalizeRadio
                        radioChange={radioChange}
                        checkRadioChange
                      />
                    </Col>
                    <Col sm={11}>
                      <RenderField
                        type="file"
                        accept={acceptFile}
                        name={`${childKey}.imageFileUpload`}
                        label="ファイル選択"
                        changeFile={handleImageFileChange}
                        disabled={!isSelectedFile}
                        checkRadioChange
                      />
                    </Col>
                    <Col sm={12}>
                      {isSelectedFile && changed && (
                        <RenderField
                          type="requiredarray"
                          name={`${childKey}.requiredarray`}
                          label="ファイル選択"
                          validates={[VALIDATE_TYPE.REQUIRED_FILE]}
                          keyArrayToCheck={`${childKey}.imageFileUpload`}
                        />
                      )}
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Col>
          </Form.Group>
        );
      });
    }
    return <div>{thumbnailPreview}</div>;
  }
}

export default ThumbNail;
